import { changeLanguage } from '@wealthbar/i18n';
import { intercom } from '@/lib/analytics';
import { setItem, getItem } from '@/lib/utils/storage';

export function getLocaleCtor(document) {
  return function execute() {
    const language = document.documentElement.lang
    || window.navigator.browserLanguage
    || window.navigator.userLanguage
    || window.navigator.language
    || '';
    return language.slice(0, 2) === 'fr' ? 'fr-CA' : 'en-CA';
  };
}

export function getLanguageCtor(getItem, setItem, document, window) {
  return function execute() {
    let currentLanguage = null;
    const match = window.location.search.match(/\blang=([^&#]*)\b/);
    const langUrl = !match ? '' : match[1].toLowerCase();
    const langStorage = getItem('language');

    if (langUrl.slice(0, 2) === 'fr') {
      currentLanguage = 'fr-CA';
    } else if (langUrl.slice(0, 2) === 'en') {
      currentLanguage = 'en-CA';
    } else if (langStorage) {
      currentLanguage = langStorage;
    } else {
      currentLanguage = getLocaleCtor(document)();
    }
    setItem('language', currentLanguage);
    return currentLanguage;
  };
}

export function setLanguageCtor(setItem, intercom, changeLanguage) {
  return async function execute(language) {
    if (language.slice(0, 2) === 'fr') {
      setItem('language', 'fr-CA');
      intercom('update', {
        hide_default_launcher: false,
        preferred_language: 'French',
        language_override: 'fr',
      });
      await changeLanguage('fr-CA');
    } else {
      setItem('language', 'en-CA');
      intercom('update', {
        hide_default_launcher: false,
        preferred_language: 'English',
        language_override: 'en',
      });
      await changeLanguage('en-CA');
    }
  };
}

export default {
  getLocale: getLocaleCtor(document),
  getLanguage: getLanguageCtor(getItem, setItem, document, window),
  setLanguage: setLanguageCtor(setItem, intercom, changeLanguage),
};
